export enum DataConflictRestoreSelection {
    NEW = 'new',
    OLD = 'old',
}
